export const useToastStore = defineStore('toast', () => {
    const visible = ref(false)
    const message = ref('')
    const variant = ref('')

    return { visible, message, variant }
})
